export default __webpack_public_path__ + "static/media/tuan.50e25e85.jpg";